<div
  *ngIf="isAm === false || (amDestination$ | finMap: 'holidayType' | async) === AmHolidayType.DP"
  class="dates-selector-root relative fill grow"
  [class.separator]="!showSingular && (isOneway$ | async) === false"
>
  <ng-container *ngIf="!showSingular">
    <fin-booking-widget-selector
      [disabled]="disabled"
      (click)="openModal()"
      [double]="
        (isOneway$ | async) === false
          ? {
              first: {
                label: 'bookingSearch.boundSelection.departureDate' | finLocalization,
                placeholder: 'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization,
                filled: (travelDates$ | async)?.['departureDate'] !== undefined
              },
              second: {
                label: 'bookingSearch.boundSelection.returnDate' | finLocalization,
                placeholder: 'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization,
                filled: (travelDates$ | async)?.['returnDate'] !== undefined
              }
            }
          : undefined
      "
      [label]="'bookingSearch.boundSelection.departureDate' | finLocalization"
      [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
      [filled]="(travelDates$ | async)?.['departureDate'] !== undefined"
      [attr.data-test-travel-dates-selector]="'both'"
    >
      <span
        *ngIf="(isOneway$ | async) === true && (travelDates$ | async)?.['departureDate'] as selectedDate"
        data-test-departure-date
        >{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span
      >
      <span first *ngIf="(travelDates$ | async)?.['departureDate'] as selectedDate" data-test-departure-date>{{
        selectedDate | finDateFormat: 'FULL_NO_YEAR'
      }}</span>
      <div
        separator
        *ngIf="(isOneway$ | async) === false && showSeparator"
        class="flex flex--center flex--self-center absolute white-bg date-spacer ps-xxsmall z2"
      >
        <fcom-icon name="minus" class="icon-medium"></fcom-icon>
      </div>
      <span second *ngIf="(travelDates$ | async)?.['returnDate'] as selectedDate" data-test-return-date>{{
        selectedDate | finDateFormat: 'FULL_NO_YEAR'
      }}</span>
    </fin-booking-widget-selector>
  </ng-container>

  <fin-booking-widget-selector
    *ngIf="showSingular as departureOrReturn"
    [disabled]="disabled"
    (click)="openModal()"
    [label]="'bookingSearch.boundSelection.' + departureOrReturn | finLocalization"
    [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
    [filled]="(travelDates$ | async)?.[departureOrReturn] !== undefined"
    [attr.data-test-travel-dates-selector]="departureOrReturn"
  >
    <span *ngIf="(travelDates$ | async)?.[departureOrReturn] as selectedDate" data-test-departure-date>{{
      selectedDate | finDateFormat: 'FULL_NO_YEAR'
    }}</span>
  </fin-booking-widget-selector>
</div>

<div *ngIf="(amDestination$ | finMap: 'holidayType' | async) === AmHolidayType.AM">
  <div class="df-laptop-up">
    <fin-am-duration-selector
      [selectedDuration]="selectedDuration$ | async"
      [durationOptions]="amDestination$ | finMap: 'holidayTypeItem.items' | async"
      (setDuration)="selectDuration($event)"
      class="flex flex--basis-half border-right"
    ></fin-am-duration-selector>
    <fin-booking-widget-selector
      class="flex flex-1"
      [disabled]="disabled"
      [position]="'right'"
      [label]="'bookingSearch.boundSelection.departureDate' | finLocalization"
      [attr.data-test-travel-dates-selector]="'departureDate'"
      (click)="openModal()"
    >
      <span *ngIf="(travelDates$ | async)?.departureDate as departureDate" data-test-departure-date>{{
        departureDate | finDateFormat: 'FULL_NO_YEAR'
      }}</span>
    </fin-booking-widget-selector>
  </div>
</div>

<fcom-modal
  [(open)]="modalOpen"
  [fitToContent]="true"
  [buttons]="null"
  [roundedContent]="true"
  [fullHeight]="true"
  [extraWide]="true"
  data-test-travel-dates-modal
>
  <fcom-datepicker
    *ngIf="'datepicker' | finLocalization as uiLabels"
    [uiLabels]="uiLabels"
    [dateLabels]="'date' | finLocalization"
    [titleAreaConfiguration]="{
      titleAreaStyle: 'ps-large-x ps-xsmall-y',
      title: datePickerTitleLabel$ | async | finLocalization,
      titleStyle: 'font-heading-4'
    }"
    [isDateRange]="(isOneway$ | async) === false"
    [selectableDatesRange]="calendarRange"
    [disabledDateRanges]="disabledDateRanges$ | async"
    [selectedDates]="[(travelDates$ | async)?.departureDate, (travelDates$ | async)?.returnDate]"
    [doneBtnHidden]="true"
    [showChips]="false"
    [headerTemplate]="(prices$ | async)?.histogram?.length > 0 ? calendarHeader : undefined"
    [dayTemplate]="dayTemplate"
    [scrollToMonthIndex$]="scrollToHistogramMonth$"
    [calendarScrollEnabled]="true"
    [isActive]="modalOpen"
    (selectedDatesChange)="updateCalendarDates($event)"
    (close)="closeModal()"
    (monthChange)="setHistogramMonth($event.monthArrayIndex)"
  ></fcom-datepicker>

  <!-- custom modal footer -->
  <div
    class="flex flex--middle ps-large-x grey-50-bg font-body-1 ps-small"
    [ngClass]="{
      'travel-dates-sticky-footer': datesSelected$ | async
    }"
    data-test-travel-dates-footer
  >
    <span class="flex flex--align-start flex--space-between fill travel-dates-footer-container">
      <ng-container *ngIf="isAm === false">
        <span data-test-date-modal-price>
          <span
            >{{
              ((isOneway$ | async)
                ? 'bookingWidget.priceCalendar.oneWayPerAdult'
                : 'bookingWidget.priceCalendar.roundTripPerAdult'
              ) | finLocalization
            }}
          </span>
          <span class="bold-type">{{
            pricePerAdult$ | async | finPrice: { stripZeroCents: true, useSymbol: true } | finEmpty: '&ndash;'
          }}</span>
        </span>
        <span class="flex--end">
          <fcom-checkbox
            [name]="'flexibleDates'"
            [checked]="flexibleDates"
            [disabled]="false"
            (change)="setFlexibleDates.emit($event)"
            data-test-flexible-dates
          >
            <span>{{ 'priceCalendar.flexibleDates' | finLocalization }}</span>
          </fcom-checkbox>
        </span>
      </ng-container>
      <span class="flex flex--middle" *ngIf="(amDestination$ | finMap: 'holidayType' | async) === AmHolidayType.AM">
        <fcom-icon class="icon-medium ms-xsmall-r" name="am-logo"></fcom-icon>
        <span>{{ 'aurinkomatkat.calendar.recommendedTravelDates' | finLocalization }}</span>
      </span>
    </span>
    <fcom-button
      [size]="ButtonSize.R_SMALL"
      [text]="'actions.done' | finLocalization"
      (click)="closeModal()"
      data-test-date-modal-close-btn
    ></fcom-button>
  </div>
</fcom-modal>

<ng-template #calendarHeader>
  <fin-histogram
    [barData$]="prices$ | finMap: 'histogram'"
    [selected$]="selectedHistogramMonth$"
    [isActive$]="modalOpen | finToObservable"
    (barSelected)="handleHistogramClick($event)"
    (barsScrolled)="handleBarsScrolled($event)"
  ></fin-histogram>
</ng-template>

<ng-template #dayTemplate let-dayValue="dayValue" let-dayString="dayString">
  <div
    class="calendar-day"
    *finLet="(prices$ | async)?.calendar?.[dayValue.id] as price"
    [attr.data-test-calendar-day]="dayValue.id"
  >
    <div
      class="ps-xxsmall-t"
      [ngClass]="{ 'aurinkomatkat-orange-text': (suggestedAmTravelDays$ | async)?.includes(dayValue.id) }"
    >
      {{ dayString }}
    </div>
    <div
      *ngIf="(prices$ | async)?.calendar"
      class="calendar-day-price font-body-2 regular-type"
      [ngClass]="{
        'heather-700-text bold-type': price?.isLowestPrice
      }"
      [attr.data-test-calendar-price]="dayValue.id"
    >
      <ng-container
        *ngTemplateOutlet="
          priceTemplate;
          context: {
            amount:
              dayValue.id >= (travelDates$ | async)?.departureDate?.id &&
              dayValue.id < (travelDates$ | async)?.returnDate?.id &&
              (isOneway$ | async) === false
                ? undefined
                : price?.amount
          }
        "
      ></ng-container>
    </div>
    <ng-template #priceTemplate let-amount="amount">
      {{ amount | finPrice: { abbreviate: true, useCustomFormat: true } | finEmpty: '&nbsp;' }}
    </ng-template>

    <div
      *ngIf="price"
      class="day-border fill absolute"
      [class.birch-300-bg]="!price?.noFlight"
      [class.grey-400-bg]="price?.noFlight"
      [attr.data-test-calendar-price-border]="dayValue.id"
    ></div>
  </div>
</ng-template>
